import { mentorsCollection, appointmentRequestsCollection } from 'configs/db';
import {
  setDoc,
  doc,
  DocumentSnapshot,
  getDoc,
  getDocs,
  query,
  QuerySnapshot,
  serverTimestamp,
  DocumentReference,
  orderBy,
  addDoc,
  updateDoc,
  where,
} from 'firebase/firestore';
import { Mentor, AppointmentRequest } from 'types';

export const queryMentors = async (
    activateOnly?: boolean,
    sortField?: string,
    direction: 'asc' | 'desc' = 'asc',
  ): Promise<QuerySnapshot<Mentor>> => {
    const q = sortField
      ? query(mentorsCollection, orderBy(sortField, direction))
      : query(mentorsCollection);
    if (activateOnly) {
      return await getDocs(query(mentorsCollection, where('isActivated', '==', true)));
    }
    return await getDocs(q);
  };
export const getMentor = async (uid: string): Promise<DocumentSnapshot<Mentor>> => {
    return await getDoc(doc(mentorsCollection, uid));
};
export const createMentor = async (
    uid: string,
    data: Mentor
  ): Promise<void> => {
    await setDoc(doc(mentorsCollection, uid), {
      ...data,
      updatedAt: serverTimestamp(),
    });
};

export const updateMentor = async (
    uid: string,
    data: Mentor
  ): Promise<void> => {
    await updateDoc(doc(mentorsCollection, uid), {
      ...data,
      updatedAt: serverTimestamp(),
    });
};

export const createAppointRequest = async (
    data: Partial<AppointmentRequest>
  ): Promise<DocumentReference> =>
    await addDoc(appointmentRequestsCollection, {
      ...data,
      createdAt: serverTimestamp(),
    });

export const activateMentor = async (id: string): Promise<void> =>
  await updateDoc(doc(mentorsCollection, id), { isActivated: true });

export const deactivateMentor = async (id: string): Promise<void> =>
  await updateDoc(doc(mentorsCollection, id), { isActivated: false });